export default __webpack_public_path__ + "static/learn-factoring-b59226bb9ac5aeb1240656886d520439.svg";